module.exports = __webpack_public_path__ + "static/media/art24.741debf0.jpg";